module.exports = "/_next/static/images/game-1-phone-uv-lock-3-51c9debf0b98ff496d5cb562b997404c.png";